import { ethers } from "ethers";
import { SiweMessage, generateNonce } from "siwe";  
import useSettings from "./useSettings";
import axios from "axios";
import { toast } from "react-toastify";
import { isAddressEqual } from "../utils/walletUtils"; 
import { useCallback } from "react"; 
import moment from "moment";

export   function useLogincheck() {  
  const { auths, onChangeauths,activeuser ,onChangeactiveuser } = useSettings();  
  async function createSiweMessage(address:string,statement:any) {
    // const res = await fetch(`${BACKEND_ADDR}/nonce`, {
    //     credentials: 'include',
    // });
    const domain = window.location.host;
    const origin = window.location.origin;
    const message = new SiweMessage({
        domain,
        address,
        statement,
        uri: origin,
        version: '1',
        chainId: 137,
        nonce: generateNonce()
    });
    return message.prepareMessage();
}

 async function handleAuthvip(useraddress:string,passcardaddress:string, signer?: ethers.Signer) {
   // const { auths, onChangeauths,activeuser ,onChangeactiveuser } = useSettings(); 
   try{
    //const signer = provider?.getSigner(); 
    const message = await createSiweMessage(
        useraddress,
        'Sign in with polygon to the dapp.'
    );
    const signature = await signer?.signMessage(message); 
    const endpoint =  process.env.REACT_APP_AUTH_BASEURL+'/authvip' || 'http://localhost:8000/authvip';  
    const  result   = await axios.post(
      endpoint,
      JSON.stringify({"useraddress":useraddress,"passcardaddress":passcardaddress,"message":message,"signature":signature}),
      { 
          headers: {
              'Content-type': `application/json` ,
              'useraddress': useraddress
          }
      });   
     console.log("Stored handleAuthenticate with result:", result);
     if(result?.data?.token){ 
          console.log("handleAuthvip result?.data?.token  :",result?.data?.token); 
          const newValue = moment.duration(6, 'days'); // moment.duration(10, 'minutes'); 
          let newauths = JSON.stringify([{"address":result?.data?.address,"role":result?.data?.role,"token":result?.data?.token,"expiry":moment().add(newValue).format('LLL')}]);
          if(auths&&auths.length>0) newauths = JSON.stringify([...JSON.parse(auths),{address:result?.data?.address,role:result?.data?.role,token:result?.data?.token,expiry:moment().add(newValue).format('LLL')}]);
           onChangeauths(newauths,useraddress,result?.data?.token);
          // onChangeactiveuser(useraddress);  
          toast.success("auth vip success!");
          return true; 
       }else{
           toast.error("auth vip fail!");
           return ;
       }
       
      
    } catch (error:any) {
      console.log(error);
      toast.error("Sign in with polygon to the dapp fail!");
      return ;
    }
}


  async function handleAuthcreator(useraddress:string,nfttokenid:number, signer?: ethers.Signer,contract?:string) {
   // const { auths, onChangeauths,activeuser ,onChangeactiveuser } = useSettings(); 
    try{
     //const signer = provider?.getSigner(); 
     const message = await createSiweMessage(
         useraddress,
         'Sign in with polygon to the dapp.'
     );
     const signature = await signer?.signMessage(message); 
     const endpoint =   process.env.REACT_APP_AUTH_BASEURL+'/authcreatorv2' || 'http://localhost:8000/authcreatorv2';  
     const  result   = await axios.post(
       endpoint,
       JSON.stringify({"useraddress":useraddress,"nfttokenid":nfttokenid,"normalercaddress":contract,"message":message,"signature":signature}),
       { 
           headers: {
               'Content-type': `application/json` ,
               'useraddress': useraddress
           }
       });   
      console.log("Stored handleAuthenticate with result:", result);
      if(result?.data?.token){ 
       // console.log("handleAuthvip result?.data?.token  :",result?.data?.token); 
       const newValue = moment.duration(6, 'days'); // moment.duration(10, 'minutes'); 
       let newauths = JSON.stringify([{"address":result?.data?.address,"role":result?.data?.role,"token":result?.data?.token,"expiry":moment().add(newValue).format('LLL')}]);
       if(auths&&auths.length>0) newauths = JSON.stringify([...JSON.parse(auths),{address:result?.data?.address,role:result?.data?.role,token:result?.data?.token,expiry:moment().add(newValue).format('LLL')}]);
         onChangeauths(newauths,useraddress,result?.data?.token);
         toast.success("auth creator success!");
         return true; 
        }else{
            toast.error("auth creator fail!");
            return ;
        }
        
       
     } catch (error:any) {
       console.log(error);
       toast.error("Sign in with polygon to the dapp fail!");
       return ;
     }
 }

   async function handleAuthkycuser(useraddress:string,kycids:number[], signer?: ethers.Signer,onweraddress?:string) {
 
    try{
    
     const message = await createSiweMessage(
         useraddress,
         'Sign in with polygon to the dapp.'
     );
     const signature = await signer?.signMessage(message); 
     const endpoint =   process.env.REACT_APP_AUTH_BASEURL+'/authkycuserv2' || 'http://localhost:8000/authkycuserv2';  
     const  result   = await axios.post(
       endpoint,
       JSON.stringify({"useraddress":useraddress,"kycids":kycids,"onweraddress":onweraddress,"message":message,"signature":signature}),
       { 
           headers: {
               'Content-type': `application/json` ,
               'useraddress': useraddress
           }
       });   
      console.log("Stored handleAuthenticate with result:", result);
      if(result?.data?.token){ 
       // console.log("handleAuthvip result?.data?.token  :",result?.data?.token); 
       const newValue = moment.duration(6, 'days'); // moment.duration(10, 'minutes'); 
       let newauths = JSON.stringify([{"address":result?.data?.address,"role":result?.data?.role,"token":result?.data?.token,"expiry":moment().add(newValue).format('LLL')}]);
       if(auths&&auths.length>0) newauths = JSON.stringify([...JSON.parse(auths),{address:result?.data?.address,role:result?.data?.role,token:result?.data?.token,expiry:moment().add(newValue).format('LLL')}]);
         onChangeauths(newauths,useraddress,result?.data?.token);
         toast.success("auth kyc user success!");
         return true; 
        }else{
            toast.error("auth kyc user fail!");
            return ;
        }
        
       
     } catch (error:any) {
       console.log(error);
       toast.error("Sign in with polygon to the dapp fail!");
       return ;
     }
 }

   const loginauth =  useCallback ((useraddress:string,passcardaddress:string, signer?: ethers.Signer,role?:number)  => {
        //  console.log("loginauth useraddress :",useraddress);
        //  console.log("loginauth activeuser :",activeuser);
        //  console.log("loginauth auths :",auths);
         if(isAddressEqual(activeuser, useraddress)) return true; 
         let newauth: any[]=[];
         if(auths&&auths.length>0) newauth = JSON.parse(auths);

        const tokenIndex = newauth?.findIndex((t:any) =>
          isAddressEqual(t?.address, useraddress)
        ); 
        if (tokenIndex > -1) {
          // console.log("loginauth onChangeactiveuser :",useraddress);
         // return auths[tokenIndex];
         onChangeactiveuser(useraddress,newauth[tokenIndex].token); 
         return true;
        }else{  
                return  handleAuthvip(useraddress,passcardaddress,signer); 
       } 

      }, [activeuser,auths]);

  
  const loginauthcreator =  useCallback ((useraddress:string,nfttokenid:number, signer?: ethers.Signer,contract?:string)  => {
        // console.log("loginauth useraddress :",useraddress);
        // console.log("loginauth activeuser :",activeuser);
        // console.log("loginauth auths :",auths);
        if(isAddressEqual(activeuser, useraddress)) return true; 
        let newauth: any[]=[];
        if(auths&&auths.length>0) newauth = JSON.parse(auths);

       const tokenIndex = newauth?.findIndex((t:any) =>
         isAddressEqual(t?.address, useraddress)
       ); 
       if (tokenIndex > -1) {
        //  console.log("loginauth onChangeactiveuser :",useraddress);
        // return auths[tokenIndex];
        onChangeactiveuser(useraddress,newauth[tokenIndex].token); 
        return true;
       }else{   
             return   handleAuthcreator(useraddress,nfttokenid,signer,contract); 
      } 

     }, [activeuser,auths]);


    
  const loginauthkycuser =  useCallback ((useraddress:string,kycids:number[], signer?: ethers.Signer,onweraddress?:string)  => {
        // console.log("loginauth useraddress :",useraddress);
        // console.log("loginauth activeuser :",activeuser);
        // console.log("loginauth auths :",auths);
        if(isAddressEqual(activeuser, useraddress)) return true; 
        let newauth: any[]=[];
        if(auths&&auths.length>0) newauth = JSON.parse(auths);

       const tokenIndex = newauth?.findIndex((t:any) =>
         isAddressEqual(t?.address, useraddress)
       ); 
       if (tokenIndex > -1) {
        //  console.log("loginauth onChangeactiveuser :",useraddress);
        // return auths[tokenIndex];
        onChangeactiveuser(useraddress,newauth[tokenIndex].token); 
        return true;
       }else{   
             return   handleAuthkycuser(useraddress,kycids,signer,onweraddress); 
      } 

     }, [activeuser,auths]);

  return {
    loginauth,
    loginauthcreator,
    loginauthkycuser,
  }  

} ;

 
 